import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TimelineMax, TweenLite, TweenMax} from "gsap";
import {Tesla} from "../../Tesla";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";
import {MathHelper} from "../../utils/MathHelper";
import {CountUpComponent} from "./components/CountUpComponent";

/**
 * Created by h3 on 2017-10-04.
 */
export class TeslaBigWinView extends BaseView {
    private _container:PIXI.Container;
    private _particlesContainer:PIXI.Container;
    private _textContainer:PIXI.Container;
    private _shakeLoop:TimelineMax;
    private _energyBall:TimelineSprite;
    private _radialEffect:TimelineSprite;
    private _ringElectro:TimelineSprite;
    private _ringEffect:TimelineSprite;
    private _textSprites:TimelineSprite[];
    private _radialRays:TimelineSprite;
    private _bgEffect:PIXI.Sprite;
    private _shakeElements:any;
    private _countUpComponent:CountUpComponent;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.BIG_WIN.name);
    }

    protected initAnimations():void {
        this._textSprites = [];
        this._shakeElements = [];

        this._particlesContainer = new PIXI.Container();
        this._layer.addChild(this._particlesContainer);

        this._container = new PIXI.Container();
        this._layer.addChild(this._container);

        this._textContainer = new PIXI.Container();
        this._layer.addChild(this._textContainer);

        this._countUpComponent = new CountUpComponent();


        this.createGraphics();
    }


    protected onResize(resizeData:IResizeData):void {
        this._container.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.5);
        this._textContainer.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.2);
        this._textContainer.scale.set(0.8, 0.8);
        this._countUpComponent.scale.set(0.8, 0.8);
    }

    private createGraphics() {
        this._bgEffect = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.BIG_WIN_BG_EFFECT)[0]);
        this._bgEffect.anchor.set(0.5, 0.5);
        this._bgEffect.scale.set(2, 2);
        this._bgEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._bgEffect.alpha = 0;

        this._energyBall = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.ENERGY_BALL));
        this._energyBall.alpha = 0;
        this._energyBall.hide();
        this._energyBall.anchor.set(0.5, 0.5);

        this._ringElectro = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.RING_ELECTRO));
        this._ringElectro.alpha = 0;
        this._ringElectro.hide();
        this._ringElectro.anchor.set(0.5, 0.5);

        this._ringEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.RING_EFFECT));
        this._ringEffect.alpha = 0;
        this._ringEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._ringEffect.hide();
        this._ringEffect.anchor.set(0.5, 0.5);

        this._radialEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.RADIAL_EFFECT));
        this._radialEffect.alpha = 0;
        this._radialEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._radialEffect.scale.set(0.5, 0.5);
        this._radialEffect.hide();
        this._radialEffect.anchor.set(0.5, 0.5);

        this._radialRays = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.RADIAL_RAYS));
        this._radialRays.alpha = 0;
        this._radialRays.blendMode = PIXI.BLEND_MODES.ADD;
        this._radialRays.scale.set(2, 2);
        this._radialRays.hide();
        this._radialRays.anchor.set(0.5, 0.5);

        this._container.addChild(this._bgEffect);
        this._container.addChild(this._ringEffect);
        this._container.addChild(this._radialRays);
        this._container.addChild(this._energyBall);
        this._container.addChild(this._ringElectro);
        this._container.addChild(this._radialEffect);
        this._container.addChild(this._countUpComponent);

    }

    private getShakeEffect() {
        this._shakeLoop = new TimelineMax({repeat : -1});
        this._shakeLoop.timeScale(1.2);

        for(let i = 0; i < this._shakeElements.length; i++) {

            const tl:TimelineLite = new TimelineLite();

            for(let j:number = 0; j < 10; j++) {
                const shakeX = MathHelper.randomNumberFromInterval(0, 0);
                const shakeY = MathHelper.randomNumberFromInterval(-5, 5);
                tl.add(new TweenLite(this._shakeElements[i].position, 0.02, {
                    x : `+=${shakeX}`,
                    y : `+=${shakeY}`
                }));
            }
            let duration = tl.totalDuration();
            this._shakeLoop.add(tl, `-=${duration}`);
        }
    }

    private stopShakeEffect() {
        if(this._shakeLoop && this._shakeLoop.isActive()) {
            this._shakeLoop.pause();
            this._shakeLoop.kill();
        }
    }

    public getBigWinAnimation(level:number, countUpValues:[number, number][]):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            this.getEffectAnimation(level),
            this._countUpComponent.getCountUpTimeline(level, countUpValues),
            this.playBigWinSound(level)
        ]);

        return tl;
    }

    private getEffectAnimation(level:number):TimelineLite {

        const tl:TimelineLite = new TimelineLite();
        this._radialEffect.alpha = 1;
        this._energyBall.alpha = 1;
        this._textContainer.alpha = 1;
        this.createParticles();

        let textSprite = this.getTextLevel(level);
        this._textContainer.addChild(textSprite);

        this._textSprites.push(textSprite);


        if(this._textSprites.length > 1) {
            tl.add(() => new TweenLite(this._textSprites[level - 1].scale, 0.2, {x : 0, y : 0}));
        }

        this._textContainer.removeChild(this._textSprites[level - 1]);


        tl.add(() => this.explosionAnimation());

        if(level > 0) {
            tl.add(() => this.stopShakeEffect());
            tl.add([
                Tesla.backgroundWindowAnimation.getWindowLightning(),
                new TweenLite(this._textSprites[level].scale, 0.25, {x : 1, y : 1}),
                () => this.getTextTimeline(this._textSprites[level]),
                new TweenLite(this._radialEffect.scale, 0.25, {x : 0.5 + level * 0.5, y : 0.5 + level * 0.5}),
                new TweenLite(this._energyBall.scale, 0.25, {x : 1 + level * 0.5, y : 1 + level * 0.5})

            ]);
            tl.add([
                () => this.getShakeEffect(),
                new TweenLite(this._bgEffect, 0.25, {alpha : 0.5})
            ]);

        } else {
            tl.add([
                Tesla.backgroundWindowAnimation.getWindowLightning(),
                new TweenLite(this._textSprites[level].scale, 0.25, {x : 1, y : 1}),
                () => this.getTextTimeline(this._textSprites[level]),
                () => this._energyBall.show(),
                () => this._radialEffect.show(),
                () => this._energyBall.playLoop(),
                () => this._radialEffect.playLoop()
            ]);

            tl.add([
                () => this.getShakeEffect(),
                new TweenLite(this._bgEffect, 0.25, {alpha : 0.5})
            ]);
        }
        return tl;
    }

    private getTextLevel(level:number):TimelineSprite {
        const textureNames:string[] = [
            TeslaGameAssets.BIW_WIN_TEXT_JOLTING,
            TeslaGameAssets.BIW_WIN_TEXT_ELECTRIFYING,
            TeslaGameAssets.BIW_WIN_TEXT_SHOCKING
        ];

        let text = new TimelineSprite(GameResources.getTextures(textureNames[level]));
        text.anchor.set(0.5, 0.5);
        text.scale.set(0, 0);

        return text;
    }

    private getTextTimeline(textSprite:TimelineSprite):TimelineMax {
        const tl:TimelineMax = new TimelineMax({repeat : -1, repeatDelay : 1});
        tl.add(textSprite.getAnimation());
        return tl;
    }

    private createParticles() {
        for(let i:number = 0; i < 25; i++) {

            const scale = MathHelper.randomNumberFromInterval(0.1, 2.5);
            const alpha = MathHelper.randomNumberFromInterval(0.2, 1);
            const startX = MathHelper.randomNumberFromInterval(0, TeslaGameConfig.instance.GAME_WIDTH);
            const startY = MathHelper.randomNumberFromInterval(TeslaGameConfig.instance.GAME_HEIGHT, TeslaGameConfig.instance.GAME_HEIGHT * 1.5);
            const velocityY = MathHelper.randomNumberFromInterval(1, 10);
            const velocityScale = MathHelper.randomNumberFromInterval(0.5, 10);

            const particle = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.BIG_WIN_PARTICLE)[0]);
            particle.anchor.set(0.5, 0.5);
            particle.blendMode = PIXI.BLEND_MODES.ADD;
            particle.scale.set(scale, scale);
            particle.alpha = alpha;
            particle.position.set(startX, startY);
            this._particlesContainer.addChild(particle);
            new TweenMax(particle, velocityY, {y : `-= ${startY * 1.1}`, repeat : -1});
            new TweenMax(particle.scale, velocityScale, {x : 0, y : 0, repeat : -1});
        }
    }

    private explosionAnimation() {
        this._ringElectro.alpha = 1;
        this._ringElectro.scale.set(1, 1);

        this._ringEffect.alpha = 1;
        this._ringEffect.scale.set(1, 1);

        const tl:TimelineMax = new TimelineMax();

        tl.add([
            () => this.radialTl(),
            new TweenLite(this._bgEffect, 0.25, {alpha : 1}),
            this._ringEffect.getAnimationAutoShowHide(true, true),
            this._ringElectro.getAnimationAutoShowHide(true, true),
            new TweenLite(this._ringElectro.scale, 0.5, {x : 10, y : 10})
        ]);

        this._ringElectro.scale.set(1, 1);

        return tl;

    }

    private radialTl() {
        const tl:TimelineLite = new TimelineLite();
        this._radialRays.alpha = 1;
        tl.add([
            () => this._radialRays.show(),
            this._radialRays.getAnimation()
        ]);
        tl.add([
            () => this._radialRays.hide()
        ]);
        return tl;
    }

    public resetBigWinView() {
        this._countUpComponent.resetCountUp();

        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this.stopShakeEffect());

        tl.add([
            new TweenLite(this._energyBall, 0.5, {alpha : 0}),
            new TweenLite(this._radialEffect, 0.5, {alpha : 0}),
            new TweenLite(this._textContainer, 0.5, {alpha : 0}),
            new TweenLite(this._bgEffect, 0.25, {alpha : 0}),
        ]);

        this._particlesContainer.removeChildren();
        this._textSprites.length = 0;
        this._energyBall.scale.set(1, 1);
        this._radialEffect.scale.set(0.5, 0.5);

        this._textContainer.removeChildren();
        this._energyBall.hide();
        this._radialEffect.hide();
        this._ringEffect.hide();
        this._ringElectro.hide();
        this._radialEffect.stopLoop();
        this._radialEffect.stopLoop();

    }

    private playBigWinSound(level:number):TimelineLite {

        const tl:TimelineLite = new TimelineLite();

        tl.add(() => SlotGame.sound.fadeAmbience(0, 0.5));

        switch(level) {
            case 0:
                tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.BIG_WIN_SMALL));
                break;
            case 1:
                tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.BIG_WIN_MEDIUM));
                break;
            case 2:
                tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.BIG_WIN_LARGE));
                break;
        }

        return tl;
    }
}